// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12p0Q","tabsBox":"styles_tabsBox__1TW9P","createButton":"styles_createButton__10Xz2"};